<template>
  <section>
    <div class="bar">
      <div v-for="(item, index) in list" :key="index">
        <el-button
          v-for="(btnItem, btnIndex) in item.children"
          :key="btnIndex"
          type="text"
          :class="{
            activeTab: item.default == `${index}-${btnIndex}`,
          }"
          @click="handleSearch(item.model, btnItem.id, index, btnIndex)"
        >
          {{ btnItem.name }}
        </el-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComSearchBar',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [
        ]
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleSearch(v, x, y, z) {
      this.$emit('search', v, x, y, z)
    }
  }
}
</script>

<style scoped lang="scss">
.bar {
  > div {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    > button {
      margin-left: 14px;
      padding-left: 22px;
      padding-right: 22px;
      @include fun-design(8);
    }
    .activeTab {
      margin-left: 28px;
      border-radius: 18px;
      font-size: 12px;
      @include fun-design(2)
    }
  }
}
</style>
